import axiosClient from "./axiosClient";

function toQueryString(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export async function getMyStorePayouts(params) {
  const response = await axiosClient.get(`/store-payouts/mine${toQueryString(params)}`);
  return response.data;
}

export async function getPendingDeliveryBalances(storeId) {
  const response = await axiosClient.get(`/store-payouts/pending-balances${toQueryString({ storeId })}`);
  return response.data;
}

export async function requestStorePayout(deliveryCompanyUserId, storeId) {
  const response = await axiosClient.post(
    `/store-payouts/request-payout${toQueryString({ storeId })}`,
    { deliveryCompanyUserId },
  );
  return response.data;
}

export async function confirmStorePayoutReceived(payoutId) {
  const response = await axiosClient.post(`/store-payouts/${payoutId}/confirm-received`);
  return response.data;
}
